export const isLocalLink = (path) => /^\/(?!\/)/.test(path);
